import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { EnvironmentUtils, BaseEnvironment, BaseApplication } from 'base';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (EnvironmentUtils.getEnvironment() !== BaseEnvironment.dev) {
  Sentry.init({
    dsn: 'https://ad28fcd337f045798a6f1cc0f544c927@o462534.ingest.us.sentry.io/6522260',
    maxBreadcrumbs: 50,
    maxValueLength: 350,
    sendClientReports: false,
    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: EnvironmentUtils.getSentryXhrLogging(),
        history: EnvironmentUtils.getSentryHistoryLogging(),
        console: false,
        dom: false,
      }),
    ],
    denyUrls: ['localhost:4200'],
    ignoreErrors: [
      'Non-Error exception captured',
      'ResizeObserver loop limit exceeded',
      'InvalidTokenError',
      'Invalid token specified',
      'Loading chunk',
    ],
    environment: environment.env,
    release: environment.global.release,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [EnvironmentUtils.getStazzleBaseUrl(BaseApplication.business)],
    sampleRate: EnvironmentUtils.getEnvironment() === BaseEnvironment.prod ? 0.5 : 1.0,
  });
}

if (environment.global.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
